import { BIGDES_IMPLEMENTATION_PROCESS_AUDIT_METHODS } from './bigdes-implementation-process-evaluation.constants.js';

export const CURRENT_SITUATION_EVALUATION_MEASURE_IMPLEMENTATION_STATUSES = [
    'implemented',
    'mostly_implemented',
    'partially_implemented',
    'compensatory_control_implemented',
    'not_implemented',
    'not_applicable',
];

export const CURRENT_SITUATION_EVALUATION_MEASURE_EFFECTIVENESS_STATUSES = [
    'effective',
    'not_effective',
    'partially_effective',
];

export const CURRENT_SITUATION_EVALUATION_CRITICALITY_LEVELS = [
    'very_high',
    'high',
    'medium',
    'low',
];

export const CURRENT_SITUATION_EVALUATION_AUDIT_METHODS = [
    'interview',
    'observation',
    'document_review',
    'technical_test',
];

export const CURRENT_SITUATION_EVALUATION_FINDING_TYPES = [
    'non_compliance',
    'improvement_suggestion',
];

export const CURRENT_SITUATION_EVALUATION_AUDIT_METHOD_OPTIONS = BIGDES_IMPLEMENTATION_PROCESS_AUDIT_METHODS;

export const CURRENT_SITUATION_EVALUATION_STATUS_NOT_EVALUATED = 'not_evaluated';

export function isCurrentSituationEvaluationMeasureEvaluated(currentSituationEvaluation) {
    if (!currentSituationEvaluation) return false;
    return Boolean(
        currentSituationEvaluation.measureImplementationStatus
        || currentSituationEvaluation.measureEffectivenessStatus
        || currentSituationEvaluation.criticalityLevel
        || currentSituationEvaluation.auditMethod
        || currentSituationEvaluation.findingType
        || (Array.isArray(currentSituationEvaluation.auditMethods) && currentSituationEvaluation.auditMethods.length)
        || (currentSituationEvaluation.auditorComment && String(currentSituationEvaluation.auditorComment).trim()),
    );
}

export function resolveCurrentSituationEvaluationMeasureStatus(currentSituationEvaluation) {
    return isCurrentSituationEvaluationMeasureEvaluated(currentSituationEvaluation)
        ? (currentSituationEvaluation?.measureImplementationStatus || 'evaluated')
        : CURRENT_SITUATION_EVALUATION_STATUS_NOT_EVALUATED;
}
